import { render } from "./IDurationTime.vue?vue&type=template&id=704e76d4"
import script from "./IDurationTime.vue?vue&type=script&lang=js"
export * from "./IDurationTime.vue?vue&type=script&lang=js"

import exportComponent from "/Users/ilya/Documents/Web/github/iTunes-Vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__